import { AxiosResponse } from 'axios';
import LoginService from 'pages/login/login.service';
import { IProduto } from 'pages/registra-venda/registra-venda.model';
import { axiosRequest } from "../axios/axios.config";

const TabelaPrecoService = () => {

    const flowPath = "/flow";
    const loginService = LoginService();

    return {
        revalidaSkus(skusUUIDS: string[], tabelaPrecoUUID: string): Promise<AxiosResponse<IProduto[]>> {
            return axiosRequest.post(
                `${flowPath}/revalidaskus`,
                { skusUUIDS, tabelaPrecoUUID },
                { headers: loginService.getHeaders() }
            );
        }
    };
};

export default TabelaPrecoService;
